'use client';
import React from 'react';
import { FooterSocial } from './components/FooterSocial/FooterSocial';
import { Container } from '@/components/client/Container/Container';
import { NavFooterList } from './components/NavFooterList/NavFooterList';
import { MainFooterInfo } from './components/MainFooterInfo/MainFooterInfo';
import style from './Footer.module.scss';
import { cn } from '@/lib/utils';
import { usePathname } from 'next/navigation';
import { microdataConfig } from '@/lib/microdata-config';

const navItems = [
  {
    title: 'Services',
    items: [
      {
        title: 'HVAC Services',
        path: '/services/heating-and-air',
        items: [
          {
            title: 'Heating Services',
            path: '/services/heating-and-air/heating',
          },
          {
            title: 'Air Conditioning Services',
            path: '/services/heating-and-air/air-conditioning',
          },
          {
            title: 'Ductless Cooling & Heating',
            path: '/services/heating-and-air/cooling-and-heating',
          },
          {
            title: 'Mini-Split Installation',
            path: '/services/heating-and-air/ductless-ac-installation',
          },
          {
            title: 'AC Installation',
            path: '/services/heating-and-air/ac-installation',
          },
          {
            title: 'Heating Installation',
            path: '/services/heating-and-air/heating-installation',
          },
          {
            title: 'Heating Maintenance',
            path: '/services/heating-and-air/heating-maintenance',
          },
        ],
      },
      {
        title: 'Electrical',
        path: '/services/electrical',
        items: [],
      },
      {
        title: 'Plumbing',
        path: '/services/plumbing',
        items: [],
      },
      {
        title: 'Remodeling',
        path: '/services/remodeling',
        items: [],
      },
      {
        title: 'New Construction',
        path: '/services/construction',
        items: [],
      },
      {
        title: 'Real Estate Brokerage',
        path: '/services/brokerage',
        items: [],
      },
    ],
  },

  {
    title: 'About Us',
    items: [
      {
        title: 'Careers',
        path: '/company/careers',
        items: [],
      },
      {
        title: 'FAQ',
        path: '/company/faq',
        items: [],
      },

      {
        title: 'Privacy and Cookie Policy',
        path: '/privacy',
        items: [],
      },

      {
        title: 'Terms and Conditions',
        path: '/terms',

        items: [],
      },
    ],
  },
  {
    title: 'Other',
    items: [
      {
        title: 'Rebates',
        path: '/rebates',
        items: [],
      },
      {
        title: 'Testimonials',
        path: '/testimonials',
        items: [],
      },
      {
        title: 'Partners',
        path: '/partners',
        items: [],
      },
    ],
  },
  {
    title: 'Contact',
    items: [
      {
        title: 'contact@tytum.com',
        items: [],
        type: 'email',
        path: 'contact@tytum.com',
      },
      {
        title: '(619) 349-4397',
        items: [],
        type: 'phone',
        path: '+16193494397',
      },
      {
        title: `16950 Via De Santa Fe, 
Suite 5060-136, 
Rancho Santa Fe, CA 92091`,
        items: [],
        type: 'location',
        path: microdataConfig.local.mapUrl,
      },
    ],
  },
];

export const Footer = () => {
  const pathname = usePathname();
  const isAdminPath = pathname.includes('/admin');
  return !isAdminPath ? (
    <footer
      className={cn(
        'text-muted-foreground w-full text-center text-sm',
        style.footer
      )}
    >
      <Container>
        <div className={style.listContainer}>
          <MainFooterInfo />
          <NavFooterList items={navItems} />
        </div>

        <div className={style.line}></div>

        <FooterSocial />
      </Container>
    </footer>
  ) : null;
};
